import { PropsWithChildren } from 'react';

import { Auth0Provider } from '@auth0/auth0-react';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';

import { AUTH0_SKIP_REDIRECT_CALLBACK } from '@/constants/auth0';
import { AuthProvider } from '@/hooks/AuthProvider';
import DemoProvider from '@/hooks/DemoProvider';
import QpsProvider from '@/hooks/QpsProvider';
import auth0Client from '@/services/auth0/auth0Client';

import QueryClientProvider from './QueryClientProvider/QueryClientProvider';

const Providers: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider>
        <DemoProvider>
          <Auth0Provider client={auth0Client} skipRedirectCallback={AUTH0_SKIP_REDIRECT_CALLBACK}>
            <AuthProvider>
              <QpsProvider>{children}</QpsProvider>
            </AuthProvider>
          </Auth0Provider>
        </DemoProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
};

export default Providers;
